import * as moment from 'moment';

import {getAcronym} from '@teem/helpers/functions';
import { proposal as ProposalApi } from '@teem/constants/api';

import { messages as i18n } from '@teem/constants/messages';

export default class ProposalsTableSchema {
	containerContext: any;

	keyColumn:string = 'uuid';
	serverUrl:string = `${ProposalApi.all}?is_draft=0`;
	headers: Array<object> = [
		{"label": "#", "thClass":"th-number"},
		{"label": $localize`:@@ts.date:Date`, "thClass":"th-date"},
		{"label": $localize`:@@ts.client:Client`, "thClass":"th-client"},
		{"label": $localize`:@@ts.project_name:Project Name`, "thClass":"th-project"},
		{"label": $localize`:@@ts.approval_status:Approval Status`, "thClass":"th-payment"},
		{"label": $localize`:@@ts.status:Status` , "thClass":"th-status text-center"}
	];
	cols: Array<object> = [
		{"key":"proposal_number", "tdClass":"td-number"},
		{"key":"quote_date", "tdClass":"td-date", 
			"render":(value) => {
				let d = moment(value);
				if(d.isValid()) {
					return (
						`<div class="date">
		                    <span class="day">${d.format('DD')}</span>
		                    <span class="month">${d.format('MMM')}</span>
		                    <span class="year">${d.format('YYYY')}</span>
		                </div>`)
					;
	            }

	            return '';
            }
        },
		{"key":"client_name", "tdClass":"td-client-name", 
			"render": (value) => `<span class="name-alpha">${value ? getAcronym(value) : ""}</span>${value ? value : ''}`},
		{"key":"title", "tdClass":"td-project-name",
			"render": (value) => {
				return `<a href="javascript:void(0);" class="proposal_title"> ${value}</a>`
			},
			"dataClick":(e, value?:any, row?:any) => {
				if(e.target.classList.contains('proposal_title')){
					this.containerContext.viewProposal(row);
				}
			},
		},
		{"key":"status", "tdClass":"td-payment", 
			"render": (value, row) => {
				let status = i18n[value] ? i18n[value] : i18n.pending;
				let colorClass = "warning";

				if(value == 'approved') {
					colorClass = 'success';
				} else if(value == 'rejected') {
					colorClass = 'highlight';
				}
				
				return `<span class="status-tag ${colorClass}">${status}</span>`;
			}
		},
		{"key":"email_status", "tdClass":"td-status", 
			"render": (value, row) => {
				let status = i18n[value] ? i18n[value] : i18n.unsent;
				let colorClass = 'highlight';

				if(value == 'viewed'){
					colorClass = 'success';
				} else if(value == 'sent') {
					colorClass = 'warning';
				}

				return `<span class="dot-status revealed ${colorClass}" ><i>${status}</i></span>`; 
			}
		}
	];

	constructor(container: any) {
		this.containerContext = container;
	}
}
